import type { ReactNode } from "react";

import { Button as RACButton } from "react-aria-components";
import { twMerge } from "tailwind-merge";

export interface SegmentedTabItem<T extends number | string = string> {
  icon?: ReactNode;
  id: T;
  isBlocked?: boolean;
  label: ReactNode;
}

export interface SegmentedTabsProps<T extends number | string = string> {
  className?: string;
  onTabChange: (tabId: T) => void;
  selectedTab: T;
  tabs: SegmentedTabItem<T>[];
}

export function SegmentedTabs<T extends number | string = string>({
  className,
  onTabChange,
  selectedTab,
  tabs,
}: SegmentedTabsProps<T>) {
  return (
    <div
      className={twMerge(
        "flex divide-x divide-border-primary overflow-hidden rounded-md border border-border-primary",
        className,
      )}
    >
      {tabs.map((tab) => (
        <RACButton
          className={twMerge(
            "cursor-pointer px-xl py-md text-sm font-semibold text-text-secondary outline-hidden gap-md flex items-center hover:bg-button-secondary-border-hover/15",
            selectedTab === tab.id &&
              "bg-button-primary-bg text-text-white hover:bg-button-primary-bg-hover",
          )}
          key={String(tab.id)}
          onPress={() => onTabChange(tab.id)}
          type="button"
        >
          {tab.icon}
          {tab.label}
        </RACButton>
      ))}
    </div>
  );
}
